import type {
  ReducedBlogInstaPost,
  ReducedTikTokVideo,
  ReducedSpotifyPlaylistType,
  BlogV2ArticleType,
  ReducedBlogV2ArticleType,
  AllReducedBlogPostsType,
  BlogAuthorFeedType,
  ReducedTagFeedType,
} from "./blog-v2-types"

import type {
  ReducedImage,
  GeneralBynderAsset,
  BlogDataForProfileType,
  ReducedGeneralLogoContainer,
  ReducedIcon,
  ReducedGeneralQuotesContainer,
  ReducedGeneralQuote,
  ReducedFAQ,
  ReducedFAQSection,
  ReducedFootnotes,
  ReducedQuickShopCarousel,
  ReducedHowItWorks,
  ReducedHowItWorksPoint,
  ReducedCategoryBlock,
  ReducedCategoryListContainer,
  ReducedInfluencer,
  ReducedInfluencersContainer,
} from "types/cms"

export const isReducedImage = (obj: unknown): obj is ReducedImage => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "BynderAsset"
  )
}

export const isBlogInstaPost = (obj: unknown): obj is ReducedBlogInstaPost => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "BlogInstaPost"
  )
}

export const isTikTokVideo = (obj: unknown): obj is ReducedTikTokVideo => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "TikTokVideo"
  )
}

export const isSpotifyPlaylist = (
  obj: unknown
): obj is ReducedSpotifyPlaylistType => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "SpotifyPlaylist"
  )
}

export const isBlogPostV2Flat = (
  data: BlogV2ArticleType | ReducedBlogV2ArticleType
): data is ReducedBlogV2ArticleType => {
  return "__typename" in data && data.__typename === "BlogV2Post"
}
export const isGeneralBynderAsset = (
  obj: unknown
): obj is GeneralBynderAsset => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "bynderData" in obj &&
    Array.isArray((obj as GeneralBynderAsset).bynderData)
  )
}

export const isBlogDataForProfile = (
  obj: unknown
): obj is BlogDataForProfileType => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "BlogV2Post"
  )
}

export const isAllReducedBlogPostsType = (
  obj: unknown
): obj is AllReducedBlogPostsType => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "BlogV2Feed"
  )
}

export const isBlogAuthorFeedType = (
  obj: unknown
): obj is BlogAuthorFeedType => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "BlogAuthorFeed"
  )
}

export const isBlogTagFeedType = (obj: unknown): obj is ReducedTagFeedType => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "BlogTagFeed"
  )
}

export const isReducedGeneralLogoContainer = (
  obj: unknown
): obj is ReducedGeneralLogoContainer => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "GeneralLogoContainer"
  )
}

export const isReducedIcon = (obj: unknown): obj is ReducedIcon => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "LandingPageIcon"
  )
}

export const isReducedGeneralQuotesContainer = (
  obj: unknown
): obj is ReducedGeneralQuotesContainer => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "LandingGeneralQuotesContainerPageIcon"
  )
}

export const isReducedGeneralQuote = (
  obj: unknown
): obj is ReducedGeneralQuote => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "GeneralQuote"
  )
}

export const isReducedFAQ = (obj: unknown): obj is ReducedFAQ => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "LandingPageFaq"
  )
}

export const isReducedFAQSection = (obj: unknown): obj is ReducedFAQSection => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "LandingPageFaqSection"
  )
}

export const isReducedQuickShopCarousel = (
  obj: unknown
): obj is ReducedQuickShopCarousel => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "PageQuickShop"
  )
}

export const isReducedFootnotes = (obj: unknown): obj is ReducedFootnotes => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "LandingPageFootnotes"
  )
}

export const isReducedHowItWorksPoint = (
  obj: unknown
): obj is ReducedHowItWorksPoint => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "HowItWorksNumberItem"
  )
}

export const isReducedHowItWorks = (obj: unknown): obj is ReducedHowItWorks => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "HowItWorksNumbers"
  )
}

export const isReducedCategoryBlock = (
  obj: unknown
): obj is ReducedCategoryBlock => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "CategoryList"
  )
}

export const isReducedCategoryListContainer = (
  obj: unknown
): obj is ReducedCategoryListContainer => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "NmhpCategoryListContainer"
  )
}

export const isReducedInfluencer = (obj: unknown): obj is ReducedInfluencer => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "ShopInfluencer"
  )
}

export const isReducedInfluencersContainer = (
  obj: unknown
): obj is ReducedInfluencersContainer => {
  return (
    typeof obj === "object" &&
    obj !== null &&
    "__typename" in obj &&
    obj.__typename === "ShopInfluencersContainer"
  )
}
